import React from 'react';
import { Text } from '@gluestack-ui/themed';
import { useTranslation } from 'react-i18next';

export const ORAL_EXAM_FILL_KIND_BADGE_TEST_ID = 'oral-exam-fill-kind-badge';

interface OralExamFillKindBadgeProps {
  testID?: string;
}

/** Compact inline preview mark for an interchangeable fill slot (not the bound fill). */
export const OralExamFillKindBadge: React.FC<OralExamFillKindBadgeProps> = ({
  testID = ORAL_EXAM_FILL_KIND_BADGE_TEST_ID,
}) => {
  const { t } = useTranslation();
  const mark = t('oralExam.fillSlot.mark');
  const a11yLabel = t('oralExam.fillSlot.a11y');

  return (
    <Text
      size="2xs"
      fontWeight="medium"
      color="$textHeading"
      bg="$bgSubtle"
      borderWidth={1}
      borderColor="$borderMedium"
      px="$1.5"
      py="$0.5"
      mx="$0.5"
      borderRadius="$md"
      selectable
      sx={{ _web: { userSelect: 'text' } }}
      testID={testID}
      accessibilityLabel={a11yLabel}
    >
      {mark}
    </Text>
  );
};

export default OralExamFillKindBadge;
